import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataImport } from 'graphql-common';
import WhiteBox from '@lib/components/WhiteBox/WhiteBox';
import Table from '@lib/components/Table/Table';
import ListEmptyState from '@lib/components/ListEmptyState/ListEmptyState';
import Trans from '@lib/components/Trans/Trans';
import { UseDataImportsQueryHookResult } from 'utils/fetch/hooks/useDataImportsQueryHook';
import ImportHistoryFilter from '../ImportHistoryFilter/ImportHistoryFilter';
import getTableActions from './utils/getTableActions';
import getTableColumns from './utils/getTableColumns';

export default function ImportHistory(props: {
  dataImportsQuery: UseDataImportsQueryHookResult;
  onDestroyDataImport: (item?: DataImport) => void;
  onCancelDataImport: (item?: DataImport) => void;
  onShowDataImportErrors: (item?: DataImport) => void;
  isSitesAvailable: boolean;
  isAssetsAvailable: boolean;
}) {
  const {
    dataImportsQuery,
    onCancelDataImport,
    onDestroyDataImport,
    onShowDataImportErrors,
    isSitesAvailable,
    isAssetsAvailable,
  } = props;

  const { t } = useTranslation();
  const tableColumns = getTableColumns({ t, onShowDataImportErrors });
  const tableActions = getTableActions({
    t,
    onDelete: onDestroyDataImport,
    onCancel: onCancelDataImport,
  });
  const tableEmptyState = (
    <ListEmptyState
      title={<Trans i18nKey="no-imports-yet" />}
      text={<Trans i18nKey="no-imports-text" />}
    />
  );
  return (
    <>
      <ImportHistoryFilter
        isSitesAvailable={isSitesAvailable}
        isAssetsAvailable={isAssetsAvailable}
      />
      <Table
        actions={tableActions}
        columns={tableColumns}
        data={dataImportsQuery.collection}
        emptyState={tableEmptyState}
        id="token"
        loading={dataImportsQuery.loading}
        totalEntries={dataImportsQuery.totalCount}
        fullHeight
      />
    </>
  );
}
